import { transformUrlResolve } from './urlResolveTransformer';
import { transformRobotsTxt } from './robotsTxtTransformer';
import { transformXmlSitemap } from './xmlSitemapTransformer';
import { transformHreflangTags } from './hreflangTagsTransformer';

export { transformUrlResolve } from './urlResolveTransformer';
export { transformRobotsTxt } from './robotsTxtTransformer';
export { transformXmlSitemap } from './xmlSitemapTransformer';
export { transformHreflangTags } from './hreflangTagsTransformer';

export const transformIndexingSection = (apiData = {}) => {
  const criteria = apiData?.criteria || {};

  const urlResolve = transformUrlResolve(criteria?.www_resolve);
  const robotsTxt = transformRobotsTxt(criteria?.robots_txt);
  const xmlSitemap = transformXmlSitemap(criteria?.sitemaps_validity);
  const hreflangTags = transformHreflangTags(criteria?.hreflang);

  const allResults = [urlResolve, robotsTxt, xmlSitemap, hreflangTags];
  const errorCount = allResults.filter((r) => r?.status === 'error').length || 0;
  const toImproveCount = allResults.filter((r) => r?.status === 'warning').length || 0;

  return {
    errorCount,
    toImproveCount,
    urlResolve,
    robotsTxt,
    xmlSitemap,
    hreflangTags,
  };
};

export default transformIndexingSection;

